const search = {
  status: 200,
  message: '',
  data: {
    // 29 下限 TODO: Done
    feeUpper: [
      {
        searchParam: 'feeUpper',
        displayName: '1,000円',
        value: '1000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '2,000円',
        value: '2000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '3,000円',
        value: '3000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '4,000円',
        value: '4000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '5,000円',
        value: '5000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '6,000円',
        value: '6000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '7,000円',
        value: '7000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '8,000円',
        value: '8000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '9,000円',
        value: '9000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '10,000円',
        value: '10000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '12,000円',
        value: '12000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '14,000円',
        value: '14000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '16,000円',
        value: '16000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '18,000円',
        value: '18000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '20,000円',
        value: '20000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '30,000円',
        value: '30000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '40,000円',
        value: '40000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '50,000円',
        value: '50000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '100,000円',
        value: '100000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '150,000円',
        value: '150000',
        total: 0
      },
      {
        searchParam: 'feeUpper',
        displayName: '200,000円',
        value: '200000',
        total: 0
      }
    ],

    // 30 上限 TODO: Done
    feeLower: [
      {
        searchParam: 'feeLower',
        displayName: '1,000円',
        value: '1000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '2,000円',
        value: '2000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '3,000円',
        value: '3000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '4,000円',
        value: '4000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '5,000円',
        value: '5000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '6,000円',
        value: '6000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '7,000円',
        value: '7000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '8,000円',
        value: '8000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '9,000円',
        value: '9000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '10,000円',
        value: '10000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '12,000円',
        value: '12000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '14,000円',
        value: '14000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '16,000円',
        value: '16000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '18,000円',
        value: '18000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '20,000円',
        value: '20000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '30,000円',
        value: '30000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '40,000円',
        value: '40000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '50,000円',
        value: '50000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '100,000円',
        value: '100000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '150,000円',
        value: '150000',
        total: 0
      },
      {
        searchParam: 'feeLower',
        displayName: '200,000円',
        value: '200000',
        total: 0
      }
    ],

    // 35 Loại hình cơ sở vật chất TODO: Done
    facility: [
      {
        searchParam: 'facility',
        displayName: 'ビジネスホテル',
        value: 'isBusinessHotel',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'シティホテル',
        value: 'isCityHotel',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'リゾートホテル',
        value: 'isResortHotel',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: '旅館',
        value: 'isRyokan',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: '民宿',
        value: 'isGuestroom',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'アパートメント',
        value: 'isApartment',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'カプセルホテル',
        value: 'isCapsuleHotel',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'ゲストハウス・ホステル・ドミトリー',
        value: 'isGuestHouseHostelDormitory',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'ペンション',
        value: 'isPension',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'コテージ・ロッジ・一棟貸',
        value: 'isCortage',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: '別荘・ヴィラ・コンドミニアム',
        value: 'isVillaCondominium',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: 'グランピング',
        value: 'isGamping',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: '町家',
        value: 'isTownist',
        total: 0
      },
      {
        searchParam: 'facility',
        displayName: '民泊（バケーションレンタル）',
        value: 'isCornerStay',
        total: 0
      }
    ],

    //38 Loại phòng TODO: Done
    roomType: [
      {
        searchParam: 'roomType',
        displayName: 'シングル',
        value: 'SINGLE',
        key: 'singleRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: 'セミダブル',
        value: 'SEMI_DOUBLE',
        key: 'semiDoubleRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: 'ダブル',
        value: 'DOUBLE',
        key: 'doubleRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: 'ツイン',
        value: 'TWIN',
        key: 'twinRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: 'トリプル',
        value: 'TRIPLE',
        key: 'youshitutriple',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: '4ベット',
        value: 'FOURTH',
        key: 'youshitufourth',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: '5ベット以上',
        value: 'FIVE',
        key: 'youshitufive',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: '和室',
        value: 'JAPANESE_STYLE',
        key: 'japaneseStyleRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: '和洋室',
        value: 'JAPANESE_AND_WESTERN',
        key: 'japaneseAndWesternRoom',
        total: 0
      },
      {
        searchParam: 'roomType',
        displayName: 'その他',
        value: 'OTHER',
        key: 'otherRoom',
        total: 0
      }
    ],

    //41 Điều kiện ăn uống TODO: Done
    mealCondition: [
      {
        searchParam: 'mealCondition',
        displayName: '食事なし',
        value: 'isNoMeal',
        total: 0
      },
      {
        searchParam: 'mealCondition',
        displayName: '夕食のみ',
        value: 'isOnlyDinner',
        total: 0
      },
      {
        searchParam: 'mealCondition',
        displayName: '朝食のみ',
        value: 'isOnlyBreakfast',
        total: 0
      },
      {
        searchParam: 'mealCondition',
        displayName: '朝食・夕食あり',
        value: 'isBothBreakfastAndDinner',
        total: 0
      }
    ],

    //44 Các điều kiện của phòng TODO: Done
    roomCondition: [
      {
        searchParam: 'roomCondition',
        displayName: '禁煙',
        value: 'isNonSmokingRoom',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: '喫煙',
        value: 'isSmokingRoom',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: '禁煙・喫煙お任せ',
        value: 'isSmokRandomFlag',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: '露天風呂付き',
        value: 'hasOpenAirBath',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: 'インターネット可',
        value: 'isInternetAllowed',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: 'ペットOK',
        value: 'isPetOk',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: '部屋で夕食',
        value: 'isSupperRoom',
        total: 0
      },
      {
        searchParam: 'roomCondition',
        displayName: 'PC貸出',
        value: 'isPClending',
        total: 0
      }
    ],

    // 48 service equip TODO: Done
    serviceEquip: [
      // 設備の露天風呂を削除
      // {
      //   searchParam: 'serviceEquip',
      //   displayName: '露天風呂',
      //   value: 'isRoomWithOpenAirBath',
      //   total: 0
      // },
      {
        searchParam: 'serviceEquip',
        displayName: '天然温泉',
        value: 'hasNaturalHotspring',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '大浴場',
        value: 'hasBigBath',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '喫煙',
        value: 'isSmokingRoom',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'サウナ',
        value: 'hasSauna',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'マッサージ',
        value: 'hasMassage',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '駐車場あり',
        value: 'hasParkingAvailable',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '屋内・屋外プール',
        value: 'hasPoolIndoorOrOutdoor',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'エステ施設',
        value: 'hasEsteFacility',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '送迎あり',
        value: 'hasTransfer',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: '卓球あり',
        value: 'hasTableTennis',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'カラオケ',
        value: 'hasKaraoke',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'ベビーベッドあり',
        value: 'hasCrib',
        total: 0
      },
      {
        searchParam: 'serviceEquip',
        displayName: 'バリアフリー対応',
        value: 'isBarrierFree',
        total: 0
      }
    ],

    //50 Phương thức sử dụng thanh toán TODO: Done
    usageMethod: [
      {
        searchParam: 'usageMethod',
        displayName: 'ベネポが貯まる',
        value: 'willBeGrantedWithPoints',
        total: 0
      },
      {
        searchParam: 'usageMethod',
        displayName: 'ベネポが使える',
        value: 'canUseBenepoint',
        total: 0
      },
      // CRM汎用独自対応↓↓↓
      // {
      //   searchParam: 'usageMethod',
      //   displayName: 'カフェテリアポイントが使える',
      //   value: 'canUseCafeteriaPoint',
      //   total: 0
      // },
      // {
      //   searchParam: 'usageMethod',
      //   displayName: '補助クーポンが使える',
      //   value: 'canUseSubsidy',
      //   total: 0
      // }
      // CRM汎用独自対応↑↑↑
      {
        searchParam: 'usageMethod',
        displayName: 'オンラインカード決済が使える',
        value: 'isCanPayment',
        total: 0
      }
    ],

    // 54 Các nhà cung cấp TODO: Done
    planByCompany: [
      {
        searchParam: 'planByCompany',
        displayName: 'Beneオリジナル',
        value: 'isNotRakuten',
        total: 0
      },
      {
        searchParam: 'planByCompany',
        displayName: 'Bene楽天トラベル',
        value: 'isRakuten',
        total: 0
      }
    ]
  }
}

// Bỏ 10, 32, 33.
export default search
